<!-- CLIENT APPS -->
<mat-spinner *ngIf="isLoading()"></mat-spinner>
  
<!-- CLIENT TOOLS OR PRODUCTS -->
<div class="product-list" *ngIf="!isLoading()">
    <!-- Card 1 -->
    <div class="product-card" *ngFor="let product of getClientProductsActive()">
      <div class="product-details">
        <h4 class="category">{{product.category}}</h4>
        <h5 class="title">{{product.product}}</h5>
        <div class="price">id: {{product.id}}</div>
        <p class="type">Type: <span>Checklist</span></p>
        <div class="status-badge paid">Paid</div>
        <div class="status-badge unpaid">Unpaid</div>
        <p class="code">Code: <span>codigo</span></p>
      </div>
      <div class="toggle-section">
        <h5 class="title">${{product.price}} </h5>
        <app-smart-toggle [element]="product" [config]="toggleConfig"></app-smart-toggle>
      </div>
    </div>
</div>